import React, { Fragment } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import FooterAccordion from './footerAccordion';

/**
 * Footer Links component
 */
const FooterLinks = ({ data }) => {
  const headingContainer = cx(
    'border-t',
    'border-gray-400',
    'lg:border-0',
    'pt-[31px]',
    'pb-[26px]',
    'pl-[18px]',
    'md:pl-[32px]',
    'lg:p-0',
    'lg:max-w-max'
  );

  const headingClass = cx('text-[32px]', 'leading-[40px]');

  const subHeadingClass = cx('text-[20px]', 'leading-[28px]');
  const firstColumnHeadingList = data.filter(
    d =>
      !d.fields.hasOwnProperty('icon') && !d.fields.hasOwnProperty('navItems')
  );
  const firstColumnHeadings = (
    <Fragment>
      {firstColumnHeadingList.map((item, index) => {
        return (
          <li
            key={item.sys.id}
            className={`${headingContainer} ${
              index !== firstColumnHeadingList.length - 1 ? 'lg:mb-[30px]' : ''
            }`}
          >
            <a
              role={'link'}
              href={item.fields.url}
              hrefLang={item.sys.locale.split('-')[0]}
              aria-label={item.fields.ariaLabel}
              rel='noreferrer'
              target={
                item.fields.urlOpenerType === 'New Tab' ? '_blank' : '_self'
              }
            >
              <h2 className={`${headingClass}`}>{item.fields.label}</h2>
            </a>
          </li>
        );
      })}
    </Fragment>
  );

  const subsequentColumns = [];
  const headingWithNavItemsList = data.filter(d =>
    d.fields.hasOwnProperty('navItems')
  );
  headingWithNavItemsList.forEach(item => {
    const headingWithNavItems = {
      label: item.fields.label,
      navItems: item.fields.navItems
    };
    subsequentColumns.push(headingWithNavItems);
  });

  return (
    <div
      className='flex flex-col lg:flex-row xl:w-3/5'
      data-testid='footer-links'
    >
      <ul className='flex flex-col w-full lg:w-1/3 lg:mr-8'>
        {firstColumnHeadings}
      </ul>
      {subsequentColumns.map(c => {
        return (
          <div key={c?.label} className='w-full lg:w-1/3'>
            <FooterAccordion
              className={`${headingContainer} lg:mx-auto`}
              HeaderElement={
                <h2 className={`${headingClass} lg:mb-[30px]`}>{c.label}</h2>
              }
            >
              <ul>
                {c.navItems.map((item, index) => {
                  return (
                    <li key={item.sys.id}>
                      <a
                        role={'link'}
                        href={item.fields.url}
                        hrefLang={item.sys.locale.split('-')[0]}
                        aria-label={item.fields.ariaLabel}
                        rel='noreferrer'
                        target={
                          item.fields.urlOpenerType === 'New Tab'
                            ? '_blank'
                            : '_self'
                        }
                      >
                        <div
                          className={`${subHeadingClass} ${
                            index !== c.navItems.length - 1 ? 'mb-[5px]' : ''
                          }`}
                        >
                          {item.fields.label}
                        </div>
                      </a>
                    </li>
                  );
                })}
              </ul>
            </FooterAccordion>
          </div>
        );
      })}
    </div>
  );
};

FooterLinks.PropTypes = {
  data: PropTypes.array.isRequired
};

export default React.memo(FooterLinks);
